import NotificationEntity from '../../entities/notification/Notification'
import React from 'react'
import { useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import { Alert, CloseButton } from './Notification.styled'
import CloseIcon from '@mui/icons-material/Close'
import { EVENT_REGISTRY } from '../../push/notificationCatalog'

export interface IOwnProps { }

export interface IStateProps {
  notification?: NotificationEntity
}

export interface IDispatchProps {
  closeNotification: (id: string) => void
}

export type IProps = IOwnProps & IStateProps & IDispatchProps

const Notification: React.FC<IProps> = (props) => {
  const {
    notification,
    closeNotification,
  } = props

  // Subscribing to intl here makes the toast re-render (and re-localize) when the
  // app language changes while it is still on screen.
  const intl = useIntl()

  if (!notification) {
    return null
  }

  const handleCloseNotification = () => {
    closeNotification(notification.id)
  }

  // Localizable notifications are re-formatted from event + params in the current
  // locale; everything else shows the stored text (server body / fallback).
  const eventDef = notification.localizable && notification.event
    ? EVENT_REGISTRY[notification.event]
    : undefined
  const message = eventDef && notification.params
    ? intl.formatMessage(eventDef.descriptor, notification.params)
    : notification.text

  return (
    <Box width='100%'>
      <Alert
        icon={false}
        severity='warning'
        variant='filled'
        action={
          <CloseButton
            color='inherit'
            size='small'
            onClick={handleCloseNotification}
          >
            <CloseIcon fontSize='inherit' />
          </CloseButton>
        }
      >
        {message}
      </Alert>
    </Box>
  )
}

export default Notification
